import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import qs from 'qs';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_ORDERS_STATISTICS = 'FETCH_ORDERS_STATISTICS';
export const FETCH_ORDERS_STATISTICS_SUCCESS = 'FETCH_ORDERS_STATISTICS_SUCCESS';
export const FETCH_ORDERS_STATISTICS_FAIL = 'FETCH_ORDERS_STATISTICS_FAIL';

// Reducer
export default function ordersStatisticsReducer(state = { data: [], loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_ORDERS_STATISTICS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_ORDERS_STATISTICS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_ORDERS_STATISTICS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchOrdersStatistics(payload) {
  return { type: FETCH_ORDERS_STATISTICS, payload };
}

export function fetchOrdersStatisticsSuccess(payload) {
  return { type: FETCH_ORDERS_STATISTICS_SUCCESS, payload };
}

export function fetchOrdersStatisticsFail(payload) {
  return { type: FETCH_ORDERS_STATISTICS_FAIL, payload };
}

// Requests
export function requestFetchOrdersStatistics(params) {
  return callApi(`info/diagram_chats_main/${qs.stringify(params, {
    encode: false, addQueryPrefix: true,
  })}`);
}

// Sagas
function* fetchOrdersStatisticsSaga(action) {
  const { triggerLoading, ...otherProps } = action.payload;
  try {
    const res = yield call(requestFetchOrdersStatistics, otherProps);
    yield put(fetchOrdersStatisticsSuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchOrdersStatisticsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* ordersStatisticsSaga() {
  yield takeEvery(FETCH_ORDERS_STATISTICS, fetchOrdersStatisticsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/ordersStatistics.js